import React from 'react';
import { Layout } from 'fronton-react';
import { useStoreon } from 'storeon/react';
import { RemoteCarousel, RootLayout, Section } from 'common/components';
import { MODEL_JSON_STORE_NAME, Offers } from 'modules/model-json';
import { convertProducts, createElementKey } from 'utils';
import { SEASON_START_BREADCRUMBS } from '../constants';
import { SeasonStartBanners } from '../components/season-start-banners';
import { SeasonStartHeader } from '../components/season-start-header';
import { SeasonStartCategories } from '../components/season-start-categories';
import {
  SEASON_START_HOUSE_ELEMENT_BLOCK,
  SEASON_START_HOUSE_PATH,
  SEASON_START_HOUSE_PRODUCTS,
  SEASON_START_HOUSE_SOLUTIONS,
  SEASON_START_HOUSE_SOLUTIONS_CATEGORIES,
} from './house-page-constants';
import { HousePageBenefits } from './components/house-page-benefits';
import { HousePageDistribution } from './components/house-page-distribution';

export const SeasonStartHouse = () => {
  const { modelJson } = useStoreon(MODEL_JSON_STORE_NAME);
  const { offers } = modelJson.model;

  return (
    <RootLayout currentPage={SEASON_START_HOUSE_PATH} customBreadcrumbs={SEASON_START_BREADCRUMBS}>
      <Layout>
        <Section>
          <SeasonStartHeader title="Обустроим комнату под ключ" />
          <HousePageDistribution elementBlock={SEASON_START_HOUSE_ELEMENT_BLOCK} />
          <HousePageBenefits />
        </Section>
        <SeasonStartCategories
          categoryList={SEASON_START_HOUSE_SOLUTIONS_CATEGORIES}
          elementBlock={SEASON_START_HOUSE_ELEMENT_BLOCK}
          title="Обновите интерьер выгодно"
        />
        <SeasonStartBanners
          bannerList={SEASON_START_HOUSE_PRODUCTS}
          elementBlock={SEASON_START_HOUSE_ELEMENT_BLOCK}
          title="Товары и услуги с выгодой"
          type="sale"
        />
      </Layout>

      {offers?.map((offer: Offers, index: number) => (
        <RemoteCarousel
          key={createElementKey('remote-carousel', index)}
          elementBlock={SEASON_START_HOUSE_ELEMENT_BLOCK}
          productIdList={convertProducts(offer.products)}
          remoteId={createElementKey('remote-carousel', index)}
          seeMoreLink={offer.link}
          showSeeMore
          title={offer.title}
        />
      ))}

      <Layout>
        <SeasonStartBanners
          bannerList={SEASON_START_HOUSE_SOLUTIONS}
          elementBlock={SEASON_START_HOUSE_ELEMENT_BLOCK}
          title="Готовые решения по суперценам"
          type="ggr"
        />
      </Layout>
    </RootLayout>
  );
}

